import { Component, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { CompilingWidgetService } from '../../../services/compiling/widget.service';
import { CheckBoxCustomization } from './checkbox-edit';

@Component({
  selector: 'lib-checkbox-compiling',
  imports: [ReactiveFormsModule, CheckboxModule],
  template: `
    @let widget = widgetService.widget();
    @let formControl = widgetService.formControl();
    @if (widget && formControl) {
      <div
        class="relative flex w-full flex-row gap-2"
        (keydown)="onKeyDown($event)"
      >
        <p-checkbox
          id="data"
          [value]="widget.customization.description"
          [binary]="true"
          [formControl]="formControl"
        />
        <label for="data" class="whitespace-normal text-justify">{{
          widget.customization.description
        }}</label>
      </div>
    }
  `,
  styleUrls: ['../style.css'],
})
export class CheckBoxCompilingComponent {
  protected widgetService = inject(
    CompilingWidgetService<CheckBoxCustomization>,
  );

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  }
}
